<template>
  <b-modal
    v-model="showModal"
    size="lg"
    title-class="font-18"
    title="Documentação Pendente"
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
  >
    <div class="d-flex justify-content-center">
      <div class="col-md-12 card">
        <div class="card-body">
          <div class="row">
            <h5 class="mt-3 mb-3 font-bold">
              Identificamos que você possui alguns documentos pendentes de
              assinatura.
              <br />
              Pedimos que regularize essa situação com urgência e se caso houver
              dúvidas, entre em contato a área de Documentação da Unicampo.<br />
              <br />
              Segue meios de comunicação:
              <br />
              E-mail: documentacao@unicampo.coop.br
              <br />
              Whatsapp: 44 99101-8595
              <br />
              Telefone: 44 4009-3859
              <br /><br />
              Vamos resolver essa pendência?
            </h5>
          </div>

          <div class="row">
            <div class="mt-5 d-flex justify-content-end">
              <b-button
                variant="success"
                class="mt-1 me-1"
                @click="assinar"
                data-tooltip="Assinar"
                data-tooltip-location="bottom"
              >
                Assinar
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      showModal: false,
    };
  },

  methods: {
    abrirModal() {
      this.showModal = true;
    },

    assinar() {
      this.showModal = false; // Isso irá fechar o modal
    },
  },
};
</script>